import React, { useEffect, useState } from 'react';
import './project.css';
import lap from '../../assets/lap.png';
import { Link, useParams } from 'react-router-dom';
import {projects} from '../../Data/Projects';

function Project({projectLoader}) {
    const { projectTitle } = useParams();
    const [projectDetails, setProjectDetails] = useState(null);
    const projectIndex = projects.findIndex(project => project.title === projectTitle);

    useEffect(() => {
        if (projectIndex !== -1) {
            setProjectDetails(projects[projectIndex]);
        }
    }, [projectTitle, projectIndex]);
    if (!projectDetails) {
        return <p>Loading...</p>;
    }

    const nextProjectIndex = (projectIndex + 1) % projects.length;
    const nextProject = projects[nextProjectIndex];

    const handleNextProject = () => {
        projectLoader(prevState => false);
    };

  return (
    <div className='project slide-in-top-animation'>
        <div className="project-container">
            <div className="project-header">
                <h2>{projectDetails.title}</h2>
                <div className="project-details">
                    <div className="project-detail">
                        <h3>ROLE/SERVICES</h3>
                        <hr />
                        <p>{projectDetails.role}</p>
                    </div>
                    <div className="project-detail">
                        <h3>YEAR</h3>
                        <hr />
                        <p>{projectDetails.year}</p>
                    </div>
                </div>
                <div className="project-detail tech">
                        <h3>Technologies used</h3>
                        <hr />
                        <p>{projectDetails.tech}</p>
                </div>
                <div className="project-btn">
                    <Link to={projectDetails.link} target="_blank" rel="noreferrer">
                        <div className="project-btn-hover"></div>
                        <p>
                            go to site
                        </p>
                    </Link>
                </div>
            </div>
            <section>
                <div className="project-normal-img">
                    <div className="project-img-container">
                        <img src={projectDetails.cover} alt="" />
                    </div>
                </div>
            </section>
            <section className='lap-section'>
                <div className="lap-container">
                    <div className="lap-row">
                        <div className="lap-col">
                            <div className="device">
                                <div className="single-img">
                                    <div className="img-overlay">
                                        <img src={projectDetails.img1} alt="" className='content-overlay' />
                                    </div>
                                </div>
                                <div className="overlay-device-img">
                                    <div className="overlay-device">
                                        <img src={lap} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='full-section' style={{ backgroundImage: `url(${projectDetails.cover})` }}>
                <div className="section-container">
                    <h3>{projectDetails.title}</h3>
                    <p>{projectDetails.details}</p>
                </div>
            </section>
            <section className='lap-section'>
                <div className="lap-container">
                    <div className="lap-row">
                        <div className="lap-col">
                            <div className="device">
                                <div className="single-img">
                                    <div className="img-overlay">
                                        <img src={projectDetails.img2} alt="" className='content-overlay' />
                                    </div>
                                </div>
                                <div className="overlay-device-img">
                                    <div className="overlay-device">
                                        <img src={lap} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="next-section">
                <Link to={`/work/${nextProject.title}`} onClick={handleNextProject}>
                    <div className="next-section-container">
                        <h3>Next Project</h3>
                        <h2 className='next-heading'>{nextProject.title}</h2>
                        <div className="next-item-wraper">
                            <div className="item-wraper">
                                <img src={nextProject.cover} alt="Img"/>
                            </div>
                        </div>
                    </div>
                </Link>
            </section>
        </div>
    </div>
  )
}

export default Project